import { Command } from "@ckeditor/ckeditor5-core";

export default class CreateLineRefsCommand extends Command {
  execute({ range }) {
    const editor = this.editor;

    editor.model.change((writer) => {
      const lineRefEnd = writer.createElement("lineRef", {
        position: "end",
      });
      const lineRefStart = writer.createElement("lineRef", {
        position: "start",
      });
      switch (range) {
        case "endOnly":
          editor.model.insertObject(lineRefEnd, null, null, {
            setSelection: "after",
          });
          break;
        case "startOnly":
          editor.model.insertObject(lineRefStart, null, null, {
            setSelection: "after",
          });
          break;
        default:
          const fragment = writer.createDocumentFragment();
          writer.append(lineRefStart, fragment);

          const dash = writer.createText("\u2013");
          writer.append(dash, fragment);

          writer.append(lineRefEnd, fragment);

          editor.model.insertContent(fragment);
          writer.setSelection(fragment, "after");
      }
    });
  }

  refresh() {
    const model = this.editor.model;
    const selection = model.document.selection;
    const allowedIn = model.schema.findAllowedParent(
      selection.getFirstPosition(),
      "lineRef",
    );

    this.isEnabled = selection.isCollapsed && allowedIn !== null;
  }
}
